module.exports = __webpack_public_path__ + "img/stats.3cbcf096.jpg";